import { cn } from '~/shadcn/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement>

function HeadingFive({ className, ...props }: Props) {
  return <h5 className={cn('text-lg font-semibold', className)} {...props} />
}

export { HeadingFive }
